/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { Int32NullableListSearch } from './Int32NullableListSearch';
import {
    Int32NullableListSearchFromJSON,
    Int32NullableListSearchFromJSONTyped,
    Int32NullableListSearchToJSON,
} from './Int32NullableListSearch';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface SiegeSocialFichierSearchDto
 */
export interface SiegeSocialFichierSearchDto {
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof SiegeSocialFichierSearchDto
     */
    fileName?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof SiegeSocialFichierSearchDto
     */
    uploadUser?: UnaccentTextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof SiegeSocialFichierSearchDto
     */
    uploadDate?: DateSearch;
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof SiegeSocialFichierSearchDto
     */
    idtypeSiegeSocialFichier?: Int32NullableListSearch;
    /**
     * 
     * @type {number}
     * @memberof SiegeSocialFichierSearchDto
     */
    idsiegeSocial?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiegeSocialFichierSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof SiegeSocialFichierSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof SiegeSocialFichierSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SiegeSocialFichierSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof SiegeSocialFichierSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeSocialFichierSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the SiegeSocialFichierSearchDto interface.
 */
export function instanceOfSiegeSocialFichierSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiegeSocialFichierSearchDtoFromJSON(json: any): SiegeSocialFichierSearchDto {
    return SiegeSocialFichierSearchDtoFromJSONTyped(json, false);
}

export function SiegeSocialFichierSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiegeSocialFichierSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': !exists(json, 'fileName') ? undefined : UnaccentTextSearchFromJSON(json['fileName']),
        'uploadUser': !exists(json, 'uploadUser') ? undefined : UnaccentTextSearchFromJSON(json['uploadUser']),
        'uploadDate': !exists(json, 'uploadDate') ? undefined : DateSearchFromJSON(json['uploadDate']),
        'idtypeSiegeSocialFichier': !exists(json, 'idtypeSiegeSocialFichier') ? undefined : Int32NullableListSearchFromJSON(json['idtypeSiegeSocialFichier']),
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function SiegeSocialFichierSearchDtoToJSON(value?: SiegeSocialFichierSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': UnaccentTextSearchToJSON(value.fileName),
        'uploadUser': UnaccentTextSearchToJSON(value.uploadUser),
        'uploadDate': DateSearchToJSON(value.uploadDate),
        'idtypeSiegeSocialFichier': Int32NullableListSearchToJSON(value.idtypeSiegeSocialFichier),
        'idsiegeSocial': value.idsiegeSocial,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

